import moment from 'moment'

import { store } from '../config/redux'
import { constants } from '../constants'
import { strings } from '../context/LanguageContext/strings'
import { util } from '../util'

export const productsDataModel = {
    getProductFilters: () => [
        {
            placed_at: 'tableToolBar',
            type: 'string',
            key: 'search',
            display_name: strings.SEARCH,
            display_value: '',
            post_value: '',
            postUtil: ({ value }) => (value === '' ? '' : { query: value }),
            defaultDisplayValue: '',
            defaultPostValue: '',
            isNotFilterSideMenu: true,
        },
        {
            type: 'list',
            key: 'meta_tags',
            display_name: strings.SECTION_PRODUCT_PAGE_TABLE_META_TAGS,
            display_value: [],
            post_value: [],
            baseFilterList: constants.getOnlineStatusMetaTagsList().map(tag => tag.value),
            displayUtil: ({ list, value }) => {
                const updatedList = [...list]
                value &&
                    value.length &&
                    updatedList.indexOf(value) === -1 &&
                    updatedList.push(value)
                return updatedList.map(
                    tag =>
                        constants.getOnlineStatusMetaTagsList().find(newTag => newTag.value === tag)
                            .display
                )
            },
            postUtil: config => {
                const onlineStatusMetaTagsList = constants.getOnlineStatusMetaTagsList()
                config.list = config.list.map(
                    value => onlineStatusMetaTagsList.find(tag => tag.display === value).value
                )
                return util.getSuggestList(config)
            },
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
        {
            type: 'string',
            key: 'catalog_type',
            display_value: strings.RIS,
            post_value: '7now',
            isNotFilterSideMenu: true,
            hideFilterPillUtil: () => true,
            defaultDisplayValue: 'RIS',
            defaultPostValue: '7now',
        },
        {
            type: 'string',
            key: 'country',
            display_value: strings.US,
            post_value: 'US',
            isNotFilterSideMenu: true,
            hideFilterPillUtil: () => true,
        },
        {
            type: 'list',
            key: 'online_status',
            display_name: strings.SECTION_PRODUCT_PAGE_TABLE_STATUS,
            display_value: [],
            post_value: [],
            displayPillUtil: function (list) {
                const settingStatusFields = constants.getSettingStatusFields()
                return list.map(
                    status =>
                        settingStatusFields.find(
                            settingStatusField => settingStatusField.value === status
                        ).display
                )
            },
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
        {
            type: 'list',
            key: 'flag',
            display_name: strings.FLAG,
            display_value: [],
            post_value: [],
            postUtil: ({ list }) => list.map(item => (item === strings.ON ? true : false)),
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
        {
            type: 'list',
            key: 'images',
            display_name: strings.PRODUCT_IMAGE,
            display_value: [],
            post_value: [],
            postUtil: ({ list }) => list.map(item => (item === strings.INCLUDED ? true : false)),
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
        {
            type: 'list',
            key: 'category_id',
            display_name: strings.MAIN_CATEGORY,
            display_value: [],
            post_value: [],
            postUtil: config => util.getIdsFromList(config),
            displayPillUtil: list => {
                return list.map(item => {
                    const categories = store
                        .getState()
                        .products.get('products_filter')
                        .find(muf => muf.key === 'category_id').baseFilterList
                    const category = categories.find(cat => cat.name === item)
                    return category.localizations?.name ?? category.name
                })
            },
            defaultDisplayValue: [],
            defaultPostValue: [],
            baseFilterList: [],
        },
        {
            type: 'list',
            key: 'sub_category_name',
            display_name: strings.SUBCATEGORY,
            display_value: [],
            post_value: [],
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
        {
            type: 'list',
            key: 'dynamic_category_id',
            display_name: strings.DYNAMIC_CATEGORY,
            display_value: [],
            post_value: [],
            displayPillUtil: list => {
                return list.map(item => {
                    const categories = store
                        .getState()
                        .products.get('products_filter')
                        .find(muf => muf.key === 'dynamic_category_id').baseFilterList
                    const category = categories.find(cat => cat.name === item)
                    return category.localizations?.name ?? category.name
                })
            },
            postUtil: config => util.getIdsFromList(config),
            defaultDisplayValue: [],
            defaultPostValue: [],
            baseFilterList: [],
        },
        {
            type: 'string',
            key: 'updated_at',
            display_name: strings.SECTION_PRODUCT_PAGE_FILTER_DATE,
            display_value: '',
            isNotFilterSideMenu: false,
            post_value: null,
            defaultDisplayValue: '',
            defaultPostValue: '',
            displayNameUtil: ({ state }) => {
                const recentUpdatedFields = constants.getRecentUpdatedFields()

                const isUpdate = state['is_update'].list
                    .map(item => recentUpdatedFields.find(ruf => ruf.value === item).display)
                    .join(', ')

                return `${strings.RECENTLY} ${isUpdate}`
            },
            displayUtil: function ({ value, list }) {
                if (value === 'Customized Dates' || typeof value !== 'string') {
                    return list
                }

                return value
            },
            displayPillUtil: value => {
                if (Array.isArray(value)) {
                    return util.getDateRangeDisplayPill(value[0], value[1])
                } else {
                    return constants
                        .getManageUpdateTimeFrameOptions()
                        .find(item => item.value === value)?.display
                }
            },
            postUtil: ({ value, list }) => {
                const today = moment()
                let startDate
                let endDate

                if (typeof value !== 'string') {
                    if (list[0] === undefined) list[0] = value[0]
                    if (list[1] === undefined) list[1] = value[1]
                    value = 'Customized Dates'
                }

                switch (value) {
                    case 'Today': {
                        startDate = today.clone()
                        endDate = today.clone()
                        break
                    }
                    case 'This week': {
                        startDate = today.clone().startOf('week')
                        endDate = today.clone().endOf('week')
                        break
                    }
                    case 'Last 7 Days': {
                        startDate = today.clone().subtract(7, 'd')
                        endDate = today.clone()
                        break
                    }
                    case 'This month': {
                        startDate = today.clone().startOf('month')
                        endDate = today.clone().endOf('month')
                        break
                    }
                    case 'Customized Dates': {
                        startDate = list[0]
                        endDate = list[1]
                        break
                    }
                    default: {
                        return null
                    }
                }

                return {
                    ...(startDate && {
                        start: util.formatStartOfDayToISO(startDate, 'MM/DD/YYYY'),
                    }),
                    ...(endDate && {
                        end: util.formatEndOfDayToISO(endDate, 'MM/DD/YYYY'),
                    }),
                }
            },
        },
        {
            type: 'list',
            key: 'is_update',
            display_name: strings.SECTION_PRODUCT_PAGE_FILTER_UPDATED,
            display_value: [],
            post_value: [],
            hideFilterPill: true,
            postUtil: ({ list }) => {
                if (!list || !list.length) {
                    return []
                }
                if (list.length > 1) {
                    return [true, true]
                } else {
                    const recentUpdatedFields = constants.getRecentUpdatedFields()
                    if (list[0] === recentUpdatedFields[0].value) {
                        return [false]
                    } else if (list[0] === recentUpdatedFields[1].value) {
                        return [true]
                    }
                }
            },
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
    ],
    getManageUpdatesFilters: () => [
        {
            type: 'string',
            key: 'is_update',
            display_value: constants.getManageUpdateTypeOptions()[0],
            post_value: false,
            postUtil: value => (value === constants.getManageUpdateTypeOptions()[0] ? false : true),
            hideFilterPillUtil: () => true,
            defaultDisplayValue: constants.getManageUpdateTypeOptions()[0],
            defaultPostValue: false,
            isNotFilterSideMenu: true,
        },
        {
            type: 'string',
            key: 'catalog_type',
            display_value: strings.RIS,
            post_value: '7now',
            isNotFilterSideMenu: true,
            hideFilterPillUtil: () => true,
        },
        {
            type: 'string',
            key: 'country',
            display_value: strings.US,
            post_value: 'US',
            isNotFilterSideMenu: true,
            hideFilterPillUtil: () => true,
        },
        {
            type: 'string',
            key: 'updated_at',
            display_name: strings.DATE,
            display_value: 'Today',
            isNotFilterSideMenu: true,
            post_value: {
                start: util.formatStartOfDayToISO(moment(), 'MM/DD/YYYY'),
                end: util.formatEndOfDayToISO(moment(), 'MM/DD/YYYY'),
            },
            displayUtil: ({ list }) => {
                if (list && list.length && list[0] === 'Customized Dates') {
                    const [startDate = null, endDate = null] = list[1]
                    return util.getDateRangeDisplayPill(startDate, endDate)
                }
                return list
            },
            postUtil: (value, customDates) => {
                const today = moment()
                let startDate,
                    endDate = null
                // eslint-disable-next-line default-case
                switch (value) {
                    case 'Today': {
                        startDate = today.clone()
                        endDate = today.clone()
                        break
                    }
                    case 'This week': {
                        startDate = today.clone().startOf('week')
                        endDate = today.clone().endOf('week')
                        break
                    }
                    case 'Last 7 Days': {
                        startDate = today.clone().subtract(7, 'd')
                        endDate = today.clone()
                        break
                    }
                    case 'This month': {
                        startDate = today.clone().startOf('month')
                        endDate = today.clone().endOf('month')
                        break
                    }
                    case 'Customized Dates': {
                        startDate = customDates.startDate
                        endDate = customDates.endDate
                        break
                    }
                }
                return {
                    ...(startDate && {
                        start: util.formatStartOfDayToISO(startDate, 'MM/DD/YYYY'),
                    }),
                    ...(endDate && {
                        end: util.formatEndOfDayToISO(endDate, 'MM/DD/YYYY'),
                    }),
                }
            },
            hideFilterPillUtil: value =>
                constants.getManageUpdateTimeFrameOptions().some(option => option.value === value)
                    ? true
                    : false,
            defaultDisplayValue: 'Today',
            defaultPostValue: {
                start: util.formatStartOfDayToISO(moment(), 'MM/DD/YYYY'),
                end: util.formatEndOfDayToISO(moment(), 'MM/DD/YYYY'),
            },
        },
        {
            placed_at: 'tableToolBar',
            type: 'string',
            key: 'search',
            display_name: strings.SEARCH,
            display_value: '',
            post_value: '',
            postUtil: ({ value }) => (value === '' ? '' : { query: value }),
            defaultDisplayValue: '',
            defaultPostValue: '',
            isNotFilterSideMenu: true,
        },
        {
            type: 'list',
            key: 'setup',
            display_name: strings.SETUP,
            display_value: [],
            post_value: [],
            postUtil: ({ list }) => list.map(value => constants.getSetupFields()[value]),
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
        {
            type: 'list',
            key: 'modified_area',
            display_name: strings.MODIFIED_AREA,
            display_value: [],
            post_value: [],
            postUtil: config => {
                const modifiedAreasList = constants.getModifiedAreasList()
                return config.list.map(area => {
                    const areaObj = modifiedAreasList.find(ma => ma.value === area)
                    return config.baseFilterList.find(key => key.endsWith(areaObj.original))
                })
            },
            defaultDisplayValue: [],
            defaultPostValue: [],
            baseFilterList: [],
        },
        {
            type: 'list',
            key: 'online_status',
            display_name: strings.SETTING_STATUS,
            display_value: [],
            post_value: [],
            displayPillUtil: function (list) {
                const settingStatusFields = constants.getSettingStatusFields()
                return list.map(
                    status =>
                        settingStatusFields.find(
                            settingStatusField => settingStatusField.value === status
                        ).display
                )
            },
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
        {
            type: 'list',
            key: 'flag',
            display_name: strings.FLAG,
            display_value: [],
            post_value: [],
            postUtil: ({ list }) => list.map(status => (status === strings.ON ? true : false)),
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
        {
            type: 'list',
            key: 'visibility',
            display_name: strings.VISIBILITY,
            display_value: [strings.DRAFT, strings.QA],
            post_value: [
                constants.getVisibilityFields()[strings.DRAFT],
                constants.getVisibilityFields()[strings.QA],
            ],
            postUtil: ({ list }) => list.map(value => constants.getVisibilityFields()[value]),
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
        {
            type: 'list',
            key: 'images',
            display_name: strings.PRODUCT_IMAGE,
            display_value: [],
            post_value: [],
            postUtil: ({ list }) =>
                list.map(status => (status === strings.INCLUDED ? true : false)),
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
        {
            type: 'list',
            key: 'category_id',
            display_name: strings.MAIN_CATEGORY,
            display_value: [],
            post_value: [],
            postUtil: config => util.getIdsFromList(config),
            displayPillUtil: list => {
                return list.map(item => {
                    const categories = store
                        .getState()
                        .products.get('manage_updates_filter')
                        .find(muf => muf.key === 'category_id').baseFilterList
                    const category = categories.find(cat => cat.name === item)
                    return category.localizations?.name ?? category.name
                })
            },
            defaultDisplayValue: [],
            defaultPostValue: [],
            baseFilterList: [],
        },
        {
            type: 'list',
            key: 'sub_category_name',
            display_name: strings.SUBCATEGORY,
            display_value: [],
            post_value: [],
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
        {
            type: 'list',
            key: 'dynamic_category_id',
            display_name: strings.DYNAMIC_CATEGORY,
            display_value: [],
            post_value: [],
            displayPillUtil: list => {
                return list.map(item => {
                    const dynamicCategories = store
                        .getState()
                        .products.get('manage_updates_filter')
                        .find(muf => muf.key === 'dynamic_category_id').baseFilterList
                    const dynamicCategory = dynamicCategories.find(cat => cat.name === item)
                    return dynamicCategory.localizations?.name ?? dynamicCategory.name
                })
            },
            postUtil: config => util.getIdsFromList(config),
            defaultDisplayValue: [],
            defaultPostValue: [],
            baseFilterList: [],
        },
    ],
}
